import React from 'react'
import Navbar from '../Components/Navbar'
import ContactHeader from '../Components/ContactHeader'

import Location from '../Components/Location'
import Footer from '../Components/Footer'
import ContactOur from '../Components/ContactOur'

const Contact = () => {
  return (
    <div>
      <Navbar/>
      <ContactHeader/>
      <ContactOur/>
      <Location/>
      <Footer/>
    </div>
  )
}

export default Contact
